import API from 'shared/constants/api';
import {
  getPriceValueBySlug,
  getFieldFromRootOrCharacteristics,
} from 'shared/helpers/transportInfo';
import { parseDecimal } from 'shared/helpers/advertForm';
import { getFormattedDateFns } from 'shared/helpers/locale';

import {
  execPostRequest,
  getLeasingParms,
  getLeasingArgumentsByAdv,
  getCleanDeviceId,
} from './utils';

// import { fetchUsersTemperature } from './finup';

// TODO: Should be removed;
export const addBitrixLead = async (props, fetch) => {
  const {
    userStorageId,
    title,
    userName,
    permalink,
    make,
    model,
    year,
    capacity,
    engine,
    gearbox,
    price,
    term,
    phone,
    isMobile,
    popularity,
    liquidityDays,
    comment,
    temperature,
    recommendedPrice,
    bkiApproved,
    prepaid,
  } = props;

  let isBkiApproved = '';
  if (typeof bkiApproved === 'boolean') {
    isBkiApproved = bkiApproved ? 'Одобрено' : 'Не Одобрено';
  }
  const commentWithAddData = [comment, `https://api.finup.lv/view/profile/${userStorageId}`].join(
    '\n',
  );

  const crmData = {
    FIELDS: {
      ID_EXTERNAL: userStorageId,
      TITLE: title,
      NAME: userName, // Имя пользо`вателя:
      LAST_NAME: '',
      UF_CRM_1627546218: userStorageId, // device id
      UF_CRM_1614238143: '', // Название финансового продукта:
      UF_CRM_1614238195: make.title, // Марка: Renault (вынести в заголовок)
      UF_CRM_1614238206: model.title, // Модель: Logan (вынести в заголовок)
      UF_CRM_1614238220: year, // Год: 2018 (вынести в заголовок)
      UF_CRM_1614238276: capacity, // Объём двигателя: 1.6 ERROR Значение поля "Объём двигателя" должно быть числом
      UF_CRM_1614238356: (engine && engine.title) || '-', // Топливо: бензин (метан)
      UF_CRM_1614238365: (gearbox && gearbox.title) || '-', // КПП: механика
      OPPORTUNITY: price, // Сумма финансирования: 5950 usd
      UF_CRM_1614238293: term || 0, //  Срок финансирования: 36
      PHONE: [{ VALUE: phone, VALUE_TYPE: 'WORK' }], // Номер телефона пользователя: +375298335599
      SOURCE_DESCRIPTION: isMobile ? 'мобильная версия' : 'десктопная версия', // Источник: мобильная версияUF_CRM_1614238143
      COMMENTS: `<a href="https://avtobazar.ua${permalink}" > avtobazar.ua${permalink}</a>`, // URL объявления, с которого отправлена заявка: https://cars.av.by/renault/logan/100203304
      UF_CRM_1614238619: '',
      UF_CRM_1614238771: '',
      UF_CRM_1614238633: '',
      UF_CRM_1614238795: '',
      CURRENCY_ID: 'USD',
      UF_CRM_1624343369: temperature || 0, //  темперетура, тип: число
      UF_CRM_1624957919: popularity || 0, // Популярность  double - popularity
      UF_CRM_1624957948: liquidityDays || 0, // Ликвидность (дней) double
      UF_CRM_1624958095: recommendedPrice || 0, // Оптимальная цена по модели  money  - recommendedPrice
      UF_CRM_1624559672749: isBkiApproved, // / Результат скоринга
      UF_CRM_1626182545: prepaid, // / Рекомендованный аванс %
      UF_CRM_1624958123: commentWithAddData, // Комментарий string - comment
      // UF_CRM_1624957985: 'test', // Падение цены в следующие 12 месяцев, (%)  double   - deflation
      // UF_CRM_1624958019: 'test', // Отклонение от рыночной цены. (%)  double   - marketPriceDeviation
      // UF_CRM_1624958062: 'test', // Медиана по рынку  money  - medianPrice
    },
  };

  return execPostRequest(API.ADVERT.LEASING.ADD_BITRIX_LEAD, crmData, fetch, {}, 'addlead');
};

// "annualRate": 0,
// "bkiRequestId": "string",
// "comment": "string",
// "currency": "USD",
// "deviceId": "string",
// "email": "string",
// "fullName": "string",
// "localId": "string",
// "phone": "string",
// "prepaid": 0,
// "sum": 0,
// "term": 0,
// "verificationId": "string"

// accepted: true
// additional: {showLeasingForm: true}
// annualRate: 40
// comment: ""
// currency: "USD"
// dailyPayment: 12.11
// id: "0c777818-659b-4f88-abc4-5de8809ffd2e"
// liquidityDays: 12
// maxPrepaid: 50
// maxTerm: 84
// minPrepaid: 43
// minTerm: 84
// monthlyPayment: 363.22
// popularity: 0.97
// prepaid: 43
// prepaidCommission: 895
// prepaidSum: 8592
// pricePrediction: {0: {price: 14627, max: 17900, min: 11900}, 1: {price: 12854, max: 16400, min: 10500},…}
// shapResponse: null
// sum: 17900
// term: 84

export const addFinupLead = async (params, verifyParams, fetch) => {
  // const { userStorageId, userName, permalink, price, term, phone, prepaid, localId } = params;
  const { userName, permalink, price, phone } = params;

  const crmData = {
    // "annualRate": 0,
    // "bkiRequestId": "string",
    // comment: `<a href="https://ab.ua${permalink}" > ab.ua${permalink}</a>`,
    // // currency: "USD",
    // deviceId: userStorageId,
    // // "email": "string",
    // fullName: userName,
    // localId,
    // phone,
    // prepaid,
    // sum: price,
    // term,
    // verificationId: verifyParams.id,

    date: new Date(),
    name: userName,
    phone,
    price,
    currency: 'USD',
    comments: '',
    link: `https://ab.ua${permalink}`,
  };
  return execPostRequest(API.ADVERT.LEASING.ADD_FINUP_LEAD, crmData, fetch, {}, 'addlead');
};

export const addAFinanceLead = async (params, fetch) => {
  const { userName, permalink, price, term, phone, prepaid, localId } = params;

  const crmData = {
    comment: params.title,
    fullName: userName,
    link: `http://avtobazar.ua${permalink}`,
    localId,
    phone,
    prepaid,
    sum: price,
    term,
  };
  return execPostRequest(API.ADVERT.LEASING.ADD_AFINANCE_LEAD, crmData, fetch, {}, 'addlead');
};

const addAutoMoneyLead = async (params, fetch) => {
  const { userName, permalink, price, term, phone, prepaid, localId } = params;

  const crmData = {
    comment: params.title,
    fullName: userName,
    link: `http://avtobazar.ua${permalink}`,
    localId,
    phone,
    prepaid,
    sum: price,
    term,
  };
  return execPostRequest(API.ADVERT.LEASING.ADD_AUTOMONEY_LEAD, crmData, fetch, {}, 'addlead');
};

/**
 * Finup /v1/verification
  * @param {Object} paramCar  {
    "brand": "string",
    "description": "string",
    "engineType": "D",
    "engineVolumeMl": 0,
    "features": [
      "ABS"
    ],
    "generation": "string",
    "mileageKm": 0,
    "model": "string",
    "transmission": "A",
    "year": 0
  }
 * @param {Object} paramOptions { "currency": "USD",  "sum": 0,  "url": "string" }
 * @param {Function} fetch 
 */
export const fetchFinupVerification = async (paramCar, paramOptions, fetch) => {
  const car = {
    brand: '',
    description: '',
    engineType: '',
    engineVolumeMl: 0,
    features: [],
    generation: '',
    mileageKm: 0,
    model: '',
    transmission: '',
    year: 0,
    ...paramCar,
  };
  const options = {
    currency: 'USD',
    sum: 0,
    url: '',
    ...paramOptions,
  };

  const body = {
    ...options,
    car,
  };

  return execPostRequest(API.ADVERT.LEASING.GET_PARAMS, body, fetch, {}, 'verification');
};

/**
 * Checks is it advert available for leasing.
 * @param {Object} advertData
 * @returns {Boolean}
 */
export const isLeasingProposalAvailable = advertData => {
  const {
    active,
    category,
    transport,
    price,
    // location,
    year,
    is_not_cleared: isNotCleared,
    is_new: isNew,
  } = advertData;

  if (getLeasingParms(advertData)) return true;

  const isAvto = (transport || category || {}).slug === 'avto';
  const usd = price.find(p => p.currency === 'usd') || {};
  const isAvailable =
    active === 1 && isAvto && !isNew && isNotCleared === false && usd.value >= 3000 && year >= 2001;
  return isAvailable;
};

export const isCreditmarketProposalAvailable = advertData => {
  const { active, category, transport, price, is_not_cleared: isNotCleared } = advertData;

  const isAvto = (transport || category || {}).slug === 'avto';
  const usd = price.find(p => p.currency === 'usd') || {};
  const isAvailable = active === 1 && isAvto && isNotCleared === false && usd.value < 3000;
  return isAvailable;
};

export const isAutoMoneyProposalAvailable = advertData => {
  const available = isLeasingProposalAvailable(advertData);
  if (!available) return false;

  const disabledRegions = [
    'odeska-oblast',
    'mykolaivska-oblast',
    'cherkaska-oblast',
    'sumska-oblast',
    'zaporizka-oblast',
    'kharkivska-oblast',
    'luhanska-oblast',
    'donetska-oblast',
  ];

  const disabledCities = ['odessa'];

  if (
    advertData.location &&
    advertData.location.slug &&
    disabledCities.includes(advertData.location.slug)
  ) {
    return false;
  }

  if (advertData.location && Array.isArray(advertData.location.parents)) {
    const inDisabledRegion = advertData.location.parents.find(
      region => region && region.slug && disabledRegions.includes(region.slug),
    );
    return !inDisabledRegion;
  }
  return available;
};

export const isCreditmarketNotClearedProposalAvailable = advertData => {
  const { active, category, transport, is_not_cleared: isNotCleared } = advertData;

  const isAvto = (transport || category || {}).slug === 'avto';
  const isAvailable = active === 1 && isAvto && isNotCleared === true;
  return isAvailable;
};

export const isMicroCreditProposalAvailable = advertData => {
  const { active, category, transport, price, is_not_cleared: isNotCleared } = advertData;

  const isAvto = (transport || category || {}).slug === 'avto';
  const usd = price.find(p => p.currency === 'usd') || {};
  const isAvailable = active === 1 && isAvto && isNotCleared === false && usd.value < 3000;
  return isAvailable;
};

export const isUlf24LeasingProposalAvailable = advertData => {
  const { active, category, transport, is_not_cleared: isNotCleared, is_new: isNew } = advertData;

  const isAvto = (transport || category || {}).slug === 'avto';
  const isAvailable = active === 1 && isAvto && isNotCleared === false && isNew;
  return isAvailable;
};

export const isUlfSomeDealersLeasingProposalAvailable = advertData => {
  // const available = isLeasingProposalAvailable(advertData);
  // if (!available) return false;
  const availableDealers = ['kij-avto-nissan', 'kij-avto-renault'];
  const slug = (advertData && advertData.agency && advertData.agency.slug) || '';
  return availableDealers.includes(slug);
};

export const isCommonLeasingProposalAvailable = advertData => {
  const { agency } = advertData;
  // TODO: should be change to some flag from Admin area.
  if (agency && agency.slug === '1-j-avtocentr-skoda') return false;
  return true;
};

export const getFinupVerification = async (adv, fetch) => {
  if (!adv || !adv.modification) {
    console.error('get Leasing by Advert failled');
    return {};
  }

  const lp = getLeasingParms(adv);
  if (lp) return lp;

  const { params, options } = getLeasingArgumentsByAdv(adv);
  const reult = await fetchFinupVerification(params, options, fetch);
  return reult;
};

export const fetchRequestId = async (params, fetch) => {
  const body = {
    bdate: getFormattedDateFns(params.birthday, 'yyyy-MM-dd'),
    deviceId: getCleanDeviceId(params.deviceId),
    phone: (params.phone || '').replace(/\s/g, ''),
  };
  return execPostRequest(API.ADVERT.LEASING.REQUEST_ID, body, fetch, {}, '');
};

export const sendCodeVerification = async (params, fetch) => {
  const body = params || {
    otp: params.otp,
    requestId: params.requestId,
  };

  return execPostRequest(API.ADVERT.LEASING.SCORING, body, fetch, {}, '');
};

export const prepareParamsForLeasingLeadRequest = (
  params,
  advert,
  leasingParams,
  moreLeasingParams,
) => {
  const { phone, userName } = params;
  const { term, popularity, liquidityDays, comment, pricePrediction, prepaid, bkiApproved } = {
    ...leasingParams,
    ...moreLeasingParams,
  };

  const decimalLength = 2;
  const intLength = 1;

  const {
    make,
    model,
    title,
    year,
    permalink,
    price,
    vehreg_info: { capacity: vehregCapacity },
    characteristics: { capacity: characterCapacity },
    capacity: simpleCapacity,
  } = advert;

  const userStorageId = localStorage.getItem('applensDeviceId') || '';
  const engine = getFieldFromRootOrCharacteristics('engine', advert);
  const gearbox = getFieldFromRootOrCharacteristics('gearbox', advert);
  const capacity =
    (characterCapacity && characterCapacity.title) ||
    simpleCapacity ||
    parseDecimal(vehregCapacity / 1000, intLength, decimalLength);
  const usaPrice = getPriceValueBySlug(price, 'usd');
  const recommendedPrice = pricePrediction && pricePrediction[0] && pricePrediction[0].price;

  return {
    userStorageId,
    title,
    userName,
    permalink,
    make,
    model,
    year,
    capacity,
    engine,
    gearbox,
    price: usaPrice,
    term,
    phone,
    isMobile: __APP__ === 'mobile',
    popularity,
    liquidityDays,
    comment,
    recommendedPrice,
    prepaid,
    bkiApproved,
  };
};

export const createMyAutoLead = async (params, advert, fetch) => {
  let result = null;

  try {
    const verifyParams = await getFinupVerification(advert, fetch);
    const finupParams = { ...params, localId: advert.id };
    result = await addFinupLead(finupParams, verifyParams, fetch);
    if (!result || !result.id) throw Error('getFinupVerification error');
  } catch (e) {
    // const temperature = await fetchUsersTemperature(params.userStorageId, fetch);
    // result = await addBitrixLead({ ...params, temperature }, fetch);
    console.log('Error');
  }
  return result;
};

export const createAFinanceLeda = async (params, advert, fetch) => {
  let result = null;

  try {
    const finupParams = { ...params, localId: advert.id };
    result = await addAFinanceLead(finupParams, fetch);
    if (!result || !result.id) throw Error('getFinupVerification error');
  } catch (e) {
    console.error(e);
  }
  return result;
};

export const createAutoMoneyLead = async (params, advert, fetch) => {
  let result = null;
  try {
    const finupParams = { ...params, localId: advert.id };
    result = await addAutoMoneyLead(finupParams, fetch);
    if (!result || !result.id) throw Error('addAutoMoneyLead error');
  } catch (e) {
    console.log(e);
  }
  return result;
};

export const getRate = async (params, fetch) =>
  execPostRequest(API.ADVERT.LEASING.GET_RATE, params, fetch, {}, 'rate');



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/myAuto.js